import { Action } from '@ngrx/store';
import { BenchmarkCurve, BenchmarkProvider } from '../../types/benchmark.types';
import { BenchmarkCurveIdentifier } from '../../types/user-preferences.types';

export enum BenchmarkCurvesActionTypes {
  LoadCurves = '[BenchmarkCurves] Load Curves',
  LoadCurvesSuccess = '[BenchmarkCurves] Load Curves Success',
  LoadCurvesFail = '[BenchmarkCurves] Load Curves Fail',
  SelectCurve = '[BenchmarkCurves] Select Curve',
  LoadWeeklyCurves = '[BenchmarkCurves] Load Weekly Curves',
  LoadWeeklyCurvesSuccess = '[BenchmarkCurves] Load Weekly Curves Success',
  LoadWeeklyCurvesFail = '[BenchmarkCurves] Load Weekly Curves Fail'
}

export class LoadCurves implements Action {
  public readonly type = BenchmarkCurvesActionTypes.LoadCurves;

  constructor(public payload: { date: string; provider: BenchmarkProvider }) {}
}

export class LoadCurvesSuccess implements Action {
  public readonly type = BenchmarkCurvesActionTypes.LoadCurvesSuccess;

  constructor(
    public payload: {
      data: BenchmarkCurve[];
      date: string;
      provider: BenchmarkProvider;
    }
  ) {}
}

export class LoadCurvesFail implements Action {
  public readonly type = BenchmarkCurvesActionTypes.LoadCurvesFail;

  constructor(public payload: { error: string; errorCode: number }) {}
}

export class SelectCurve implements Action {
  public readonly type = BenchmarkCurvesActionTypes.SelectCurve;

  constructor(public payload: BenchmarkCurveIdentifier) {}
}

export class LoadWeeklyCurves implements Action {
  public readonly type = BenchmarkCurvesActionTypes.LoadWeeklyCurves;

  constructor(public payload: { date: string; provider: BenchmarkProvider }) {}
}

export class LoadWeeklyCurvesSuccess implements Action {
  public readonly type = BenchmarkCurvesActionTypes.LoadWeeklyCurvesSuccess;

  constructor(
    public payload: {
      data: BenchmarkCurve[];
      date: string;
      provider: BenchmarkProvider;
    }
  ) {}
}

export class LoadWeeklyCurvesFail implements Action {
  public readonly type = BenchmarkCurvesActionTypes.LoadWeeklyCurvesFail;

  constructor(public payload: { error: string; errorCode: number }) {}
}

export type BenchmarkCurvesActionUnion =
  | LoadCurves
  | LoadCurvesSuccess
  | LoadCurvesFail
  | SelectCurve
  | LoadWeeklyCurves
  | LoadWeeklyCurvesSuccess
  | LoadWeeklyCurvesFail;
